module.exports = __webpack_public_path__ + "img/emojis_sprite.86f64f7.webp";